import { BotzappingDomainSummary, DashboardSummaryDataEntry } from 'Features/home/api/types'
import { PaidMarketingDomainSummary } from 'Types/DomainPerformance'
import { TableRow } from './ActiveDomainsTable'
import { add, endOfToday, startOfDay } from 'date-fns'
import { ReducedThreatGroupsBreakdown } from 'Features/home/routes/Home/types'

export const isActiveDomain = (row: TableRow) => {
  return (
    row.botZappingConnected || row.paidMarketingConnected
    // row.tagInstalled &&
    // row.active &&
    // row.visits &&
    // row.visits > 0
  )
}

export const BaseBotzappingSummary: BotzappingDomainSummary = {
  domain: '',
  totalVisits: 0,
  totalBlocked: 0,
  blockedPageloads: 0,
  blockedSiteInteractions: 0,
  invalidRate: 0,
  protectedValidVisitsPercentage: 0,
  protectedVisits: 0,
  protectedValidVisits: 0,
  whiteListed: 0,
  whiteListedPercentage: 0,
}

export const mapPaidMarketingSummary = (summary: Array<DashboardSummaryDataEntry>) => {
  const result = summary.reduce((r: PaidMarketingDomainSummary[], { domain, visits, invalid }) => {
    let item: PaidMarketingDomainSummary | undefined = r.find(
      (o: PaidMarketingDomainSummary) => o.domain === domain
    )
    if (!item) {
      item = { domain, visits: 0, invalid: 0 }
      r.push(item)
    }
    item.visits += visits
    item.invalid += invalid
    return r
  }, [])

  return result
}

export const mapBotzappingData = (summary: BotzappingDomainSummary[]) => {
  const result = summary.reduce(
    (r: BotzappingDomainSummary[], { domain, totalVisits, totalBlocked }) => {
      let item: BotzappingDomainSummary | undefined = r.find(
        (o: BotzappingDomainSummary) => o.domain === domain
      )
      if (!item) {
        item = { ...BaseBotzappingSummary, domain }
        r.push(item)
      }
      item.totalVisits += totalVisits
      item.totalBlocked += totalBlocked

      return r
    },
    []
  )

  return result
}

export const filterOutVisitisByStartDate = (
  data: (ReducedThreatGroupsBreakdown & { visits: [number, number][] }) | undefined,
  date: number | undefined
) => {
  if (!data || !date) return data
  return {
    ...data,
    visits: data.visits.filter(([first]) => first >= date),
  }
}

export const LASR_7_DAYS = {
  from: startOfDay(add(new Date(), { days: -7 })),
  to: endOfToday(),
}

export const paginationLimit = 15
